import { Component, Input, OnInit } from '@angular/core'
import { MenuSettingSelectorLevel3Colum1, MenuSettingSelectorLevel3Colum2, MenuSettingStore, PrepareSubMenuColumnBanner, SubMenuColumnBanner } from '@cms/store/MenuSetting'

@Component({
  selector: 'ket-move-layer-manu',
  templateUrl: './move-layer-manu.component.html',
  styleUrls: ['./move-layer-manu.component.scss'],
})
export class KetMoveLayerManuComponent implements OnInit {
  @Input() data: {
    page: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0]
  }

  model: {
    radioValue: 'main' | 'sub'
    page_id: number
  } = { radioValue: 'main', page_id: null }
  res: {
    layer1: ReturnType<typeof MenuSettingStore.get>['changing']['menu']
    layer2: ReturnType<typeof MenuSettingStore.get>['changing']['menu']
  } = {
    layer1: [],
    layer2: [],
  }
  selectedLang = 'lang1'
  message_duration = 4000
  MenuSettingStore = MenuSettingStore

  disbled = {
    main: false,
    sub: false,
    layer1: false,
    layer2: false,
    page_parent: 0
  }

  constructor() {}

  async ngOnInit() {
    const state = MenuSettingStore.get()
    const check = state.changing.menu.find((item) => item.page_id == this.data.page.page_id)
    if (check) {
      this.disbled.main = true
      this.model.radioValue = 'sub'
      let layer = 1
      if (check.childrens && check.childrens.length > 0) {
        layer = 2
        for (const item of check.childrens) {
          if (item.childrens && item.childrens.length > 0) {
            layer = 3
            break
          }
        }
      }
      // disable
      if (layer === 2) {
        this.disbled.layer2 = true
      }
      if (layer === 3) {
        this.disbled.sub = true
      }
    } else {
      let item: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0] | undefined
      for (const _item of state.changing.menu) {
        if (_item.childrens && _item.childrens.length > 0) {
          item = _item.childrens.find((item) => item.page_id == this.data.page.page_id)
          if (item) {
            break
          } else {
            for (const _child of _item.childrens) {
              if (_child.childrens && _child.childrens.length > 0) {
                item = _child.childrens.find((item) => item.page_id == this.data.page.page_id)
                if (item) {
                  break
                }
              }
            }
          }
        }
        if (item) {
          break
        }
      }
      if (item) {
        this.disbled.main = false
        let layer = 1
        if (item.childrens && item.childrens.length > 0) {
          layer = 2
        }
        if (layer === 2) {
          this.disbled.layer2 = true
        }
        this.disbled.page_parent = item.page_parent
      }
    }
  }

  async ok() {
    if (this.model.radioValue === 'main' && this.disbled.main) {
      return false
    }
    if (this.model.radioValue === 'sub' && !this.model.page_id) {
      return false
    }

    const modal_move: { from_id: number; to_type: 'main' | 'sub'; to_id?: number } = {
      from_id: this.data.page.page_id,
      to_type: this.model.radioValue,
    }

    if (this.model.radioValue === 'sub') {
      modal_move.to_id = this.model.page_id
    }

    const state = MenuSettingStore.get()
    let item = state.changing.menu.find((item) => item.page_id == modal_move.from_id)
    let main = undefined as (typeof state.changing.menu)[0] | undefined
    if (!item) {
      for (const _item of state.changing.menu) {
        if (item) break
        if (_item.childrens && _item.childrens.length > 0) {
          item = _item.childrens.find((item) => item.page_id == modal_move.from_id)
          // console.log('item', _item.page_id, modal_move.from_id, item)
          if (!item) {
            for (const _child of _item.childrens) {
              if (_child.childrens && _child.childrens.length > 0) {
                item = _child.childrens.find((item) => item.page_id == modal_move.from_id)
                // console.log('item', item)
                if (item) {
                  main = _child
                  break
                }
              }
            }
          } else {
            main = _item
            break
          }
        }
      }
    }
    // console.log('item', item)
    if (!item) return false
    if (main) {
      main.childrens = main.childrens.filter((x) => x.page_id !== item.page_id)
      console.log('main', main)
    } else {
      state.changing.menu = state.changing.menu.filter((x) => x.page_id !== item.page_id)
    }
    let stateL3C1 = MenuSettingSelectorLevel3Colum1.get()
    stateL3C1 = stateL3C1.filter((x) => x.page_id !== item.page_id)
    MenuSettingSelectorLevel3Colum1.set(stateL3C1)
    let stateL3C2 = MenuSettingSelectorLevel3Colum2.get()
    stateL3C2 = stateL3C2.filter((x) => x.page_id !== item.page_id)
    MenuSettingSelectorLevel3Colum2.set(stateL3C2)

    let smb = Object.values(SubMenuColumnBanner.get())
    smb = smb.filter((x) => x.find((y) => y.page_id !== item.page_id))
    SubMenuColumnBanner.set({})
    const map = {} as {
      [key: string]: ReturnType<typeof MenuSettingStore.get>['changing']['menu'][0][]
    }
    smb.forEach((item, index) => {
      if (item && item.length > 0) {
        map[index + 1] = item
      }
    })
    SubMenuColumnBanner.set(map)

    // find to_id
    let to_item = state.changing.menu.find((item) => item.page_id == modal_move.to_id)
    if (!to_item) {
      for (const _item of state.changing.menu) {
        if (_item.childrens && _item.childrens.length > 0) {
          to_item = _item.childrens.find((item) => item.page_id == modal_move.to_id)
          if (!to_item) {
            for (const _child of _item.childrens) {
              if (_child.childrens && _child.childrens.length > 0) {
                to_item = _child.childrens.find((item) => item.page_id == modal_move.to_id)
                if (to_item) {
                  break
                }
              }
            }
          } else {
            break
          }
        }
      }
    }

    if (!item.childrens) {
      item.childrens = []
    }
    if (to_item && this.model.radioValue === 'sub') {
      to_item.childrens.push(item)
    } else {
      state.changing.menu.push(item)
    }
    PrepareSubMenuColumnBanner()
    return true
  }
}
